import { Component } from "react";
import { v4 as uuidv4 } from "uuid";
import { datadogLogs } from '@datadog/browser-logs';
import { IDWSession } from "@idw-types/data/idw-session";
import { ErrorBoundaryModal } from "./error-boundary-modal/error-boundary-modal";

type ErrorBoundaryProps = {
    session: IDWSession;
    children: React.ReactNode;
};

type ErrorBoundaryState = {
    error: Error;
    errorId: string;
};

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {

    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { error: null, errorId: uuidv4() };
    }

    static getDerivedStateFromError(error: Error) {
        // Update state so the next render will show the fallback UI.
        return { error: error };
    }

    componentDidCatch(error: Error) {
        const errorMessage = `Error Boundary displayed with Error: ${error}`;
        const errorContext = {
            url: window.location.pathname,
            error: error,
            userId: this.props.session?.userID,
            timestamp: new Date(),
            errorId: this.state.errorId
        };
        datadogLogs.logger.error(errorMessage, errorContext);
    }

    clearError = () => {
        window.location.reload();
    }

    render() {
        const { error } = this.state;
        if (error) {
            return <ErrorBoundaryModal clearError={this.clearError} errorId={this.state.errorId} />;
        } else {
            return <>{this.props.children}</>;
        }
    }
}